export { default as ConfirmationPage } from './Pay/Confirmation';
